import type { MetaAttribution } from "@/utils/metaAttribution";

const API_URL = import.meta.env.VITE_API_URL || "";

export async function createCheckoutSession(
  email: string,
  priceId: string,
  ref?: string,
  attribution: MetaAttribution = {}
): Promise<{ url: string; sessionId: string }> {
  const res = await fetch(`${API_URL}/payments/checkout-session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, priceId, ...(ref ? { ref } : {}), ...attribution }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to create checkout session");
  }
  return res.json();
}

export async function getCheckoutSessionSummary(sessionId: string): Promise<{
  sessionId: string;
  amountTotal: number;
  currency: string;
  planName: string;
  priceId: string;
}> {
  const res = await fetch(`${API_URL}/payments/checkout-session/${sessionId}`);
  if (!res.ok) throw new Error("Failed to fetch checkout session");
  return res.json();
}

export async function getSubscription(): Promise<any> {
  const res = await fetch(`${API_URL}/payments/subscription`, {
    credentials: "include",
  });
  if (!res.ok) throw new Error("Failed to fetch subscription");
  return res.json();
}

export async function createPortalSession(returnUrl?: string): Promise<{ url: string }> {
  const res = await fetch(`${API_URL}/payments/customer-portal`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ returnUrl }),
  });
  if (!res.ok) throw new Error("Failed to create portal session");
  return res.json();
}
